var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFinanceAccount = function SvgFinanceAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.7,
    strokeLinejoin: "round",
    d: "m3.37 12.17 3.5-3.5 2 2 6.05-6.681"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    strokeWidth: 1.7,
    cx: 8.35,
    cy: 3,
    r: 2.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.944 1.885v1.7L1.7 3.584v11.663h12.476V8.36h1.7v7.089a1.5 1.5 0 0 1-1.5 1.5H1.5a1.5 1.5 0 0 1-1.5-1.5V3.385a1.5 1.5 0 0 1 1.5-1.5h4.444Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))));
};
export default SvgFinanceAccount;